<template>
  <q-item class="module-item">
    <q-item-section>
      <div class="flex full-width no-wrap items-center">
        <div
          v-if="withSelection"
          class="relative-position text-center"
          style="flex: 0 0 40px;"
        >
          <q-skeleton
            animation="fade"
            type="rect"
            width="20px"
          />
        </div>

        <RowCell
          v-for="(header, key) in headers"
          :key="key"
          :header="header"
        >
          <q-item-label>
            <q-skeleton
              animation="fade"
              :type="header.fixed === true && key === 0 ? 'QToggle' : 'text'"
              :size="header.fixed === true && key === 0 ? '36px' : undefined"
            />
          </q-item-label>
        </RowCell>
      </div>
    </q-item-section>
  </q-item>
</template>

<script>
import RowCell from './TableRowCell'

export default {
  components: {
    RowCell
  },
  props: {
    withSelection: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      required: true
    }
  }
}
</script>
